import { lazy } from "react"

const NewPairAssignmentsPage$$__react__lazy__component = lazy(() => 
    import("./NewPairAssignmentsPage__original__module.mjs")
        .then(module => module.get_$$NewPairAssignmentsPage$$NewPairAssignmentsPage$$react__component$$fhalch3bam0i())
        .then(component => ({ default: component }))
)

export const get_$$NewPairAssignmentsPage$$NewPairAssignmentsPage$$react__component$$fhalch3bam0i = () => NewPairAssignmentsPage$$__react__lazy__component